import React, { useState, useRef } from 'react';
import {
    Box,
    Grid,
    Typography,
    TextField,
    Button,
    IconButton,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions
} from '@mui/material';
import { styled } from '@mui/material/styles';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CloseIcon from '@mui/icons-material/Close';
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import axios from "axios";
import { RUTA_API_SUELDOS } from "../../Contantes/Constantes";
import { useBody } from "../../Body/state/BodyContext";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';

const DropZone = styled(Box)(({ theme, isDragging }) => ({
    border: '2px dashed #ccc',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(4),
    textAlign: 'center',
    backgroundColor: isDragging ? '#f0f0f0' : '#fafafa',
    color: '#888',
    cursor: 'pointer',
    minHeight: '120px',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
}));

const FileDisplay = ({ file, onRemove }) => {
    const extension = file.name.split('.').pop()?.toLowerCase();

    const getIcon = () => {
        if (['xls', 'xlsx'].includes(extension)) {
            return (
                <Box
                    component="img"
                    src="https://img.icons8.com/ios-filled/70/000000/ms-excel.png"
                    alt="Excel"
                    sx={{ width: 25, height: 25, mr: 2 }}
                />
            );
        }

        return <InsertDriveFileIcon sx={{ fontSize: 25, color: '#555', mr: 2 }} />;
    };

    return (
        <Box display="flex" alignItems="center" p={1.5} border="1px solid #ccc" borderRadius={2}>
            {getIcon()}
            <Typography
                variant="body2"
                sx={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}
            >
                {file.name}
            </Typography>
            <IconButton onClick={onRemove}>
                <CloseIcon sx={{ color: '#b71234' }} />
            </IconButton>
        </Box>
    );
};

const TabSueldos = () => {
    const axiosInstance = setupInterceptorsTo(axios.create());
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modificadoDesdeUltimaConversion, setModificadoDesdeUltimaConversion] = useState(true);
    const [sueldosArchivo, setSueldosArchivo] = useState([]);
    const { setSuccess, setMessage } = useBody();
    const [adelantosArchivo, setAdelantosArchivo] = useState(null);
    const [dragOver, setDragOver] = useState(null);
    const [estadoEnvio, setEstadoEnvio] = useState("idle");
    const [montoTotal, setMontoTotal] = useState(0);
    const [cantRegistros, setCantRegistros] = useState(0);
    const [campos, setCampos] = useState({
        nroConvenio: '',
        nroEnvio: '',
        fechaAcreditacion: '',
        tipoMov: '',
        codConcepto: ''
    });

    const [errores, setErrores] = useState({});

    const inputSueldosRef = useRef();
    const inputAdelantosRef = useRef();

    const handleMultiFileInput = (e, setFiles) => {
        const files = Array.from(e.target.files);
        const validFiles = files.filter(file => file.name.toLowerCase().endsWith('.dbf'));

        if (validFiles.length > 0) {
            setFiles((prev) => {
                const nuevos = [...prev, ...validFiles].slice(0, 6);
                return nuevos;
            });
        } else {
            setMessage("Solo se permiten archivos .dbf");
        }

        setEstadoEnvio("idle");
        setModificadoDesdeUltimaConversion(true);
    };

    const handleMultiFileDrop = (e, setFiles) => {
        e.preventDefault();
        setDragOver(null);
        const files = Array.from(e.dataTransfer.files);
        const validFiles = files.filter(file => file.name.toLowerCase().endsWith('.dbf'));

        if (validFiles.length > 0) {
            setFiles((prev) => {
                const nuevos = [...prev, ...validFiles].slice(0, 6);
                return nuevos;
            });
        } else {
            setMessage("Solo se permiten archivos .dbf");
        }

        setEstadoEnvio("idle");
    };


    const handleRemoveSueldoArchivo = (index) => {
        setSueldosArchivo((prev) => prev.filter((_, i) => i !== index));
        setEstadoEnvio("idle");
        setModificadoDesdeUltimaConversion(true);
    };

    const handleFileInput = (e, setFile) => {
        const file = e.target.files[0];
        if (file && (file.name.endsWith('.xls') || file.name.endsWith('.xlsx'))) {
            setFile(file);
        } else {
            setMessage("Solo se permiten archivos Excel (.xls, .xlsx)");
        }
        setEstadoEnvio("idle");
        setModificadoDesdeUltimaConversion(true);
    };

    const handleFileDrop = (e, setFile) => {
        e.preventDefault();
        setDragOver(null);
        const file = e.dataTransfer.files[0];
        if (file && (file.name.endsWith('.xls') || file.name.endsWith('.xlsx'))) {
            setFile(file);
        } else {
            setMessage("Solo se permiten archivos Excel (.xls, .xlsx)");
        }
        setEstadoEnvio("idle");
        setModificadoDesdeUltimaConversion(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;

        if (['nroConvenio', 'nroEnvio'].includes(name)) {
            newValue = value.replace(/[^\d]/g, '');
        }
        if (name === 'nroEnvio') {
            newValue = value.replace(/[^\d]/g, '').slice(0, 2);
        }
        if (['tipoMov', 'codConcepto'].includes(name)) {
            newValue = value.replace(/[^\d]/g, '').slice(0, 1);
        }
        if (name === 'nroConvenio') {
            newValue = value.replace(/[^\d]/g, '').slice(0, 3);
        }

        setCampos({
            ...campos,
            [name]: newValue,
        });

        setEstadoEnvio("idle");
        setModificadoDesdeUltimaConversion(true);
    };
    const handleConvert = async () => {
        const nuevosErrores = {};
        if (sueldosArchivo.length === 0) {
            setMessage("Debés subir al menos un archivo .dbf");
            return;
        }
        if (!campos.nroConvenio) nuevosErrores.nroConvenio = 'Este campo es obligatorio';
        if (!campos.fechaAcreditacion) nuevosErrores.fechaAcreditacion = 'Este campo es obligatorio';
        if (!campos.nroEnvio) nuevosErrores.nroEnvio = 'Este campo es obligatorio';
        if (!campos.tipoMov) nuevosErrores.tipoMov = 'Este campo es obligatorio';
        if (!campos.codConcepto) nuevosErrores.codConcepto = 'Este campo es obligatorio';

        setErrores(nuevosErrores);
        if (Object.keys(nuevosErrores).length > 0) return;

        try {
            const formData = new FormData();
            sueldosArchivo.forEach(file => formData.append('sueldosArchivo[]', file));
            if (adelantosArchivo) {
                formData.append('adelantosArchivo', adelantosArchivo, 'adelantos.xlsx');
            }

            const response = await axiosInstance.post(
                `${RUTA_API_SUELDOS}/procesamiento-provisorio`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    responseType: 'json',
                }
            );

            if(response.status === 200){
                setCantRegistros(response.data.cantSueldos)
                setMontoTotal(response.data.montoTotal)
                setModalAbierto(true);
                return;
            }
            else throw new Error("Error en la respuesta del servidor");
        } catch (error) {
            let mensajeError;
            if (error.response?.status === 403) mensajeError = 'No tenés permiso para realizar esta acción.';
            if (error.response?.status === 401) mensajeError = 'No estás autorizado para realizar esta acción.';
            if (error.response?.status === 500) mensajeError = error.response.data || 'Error en los datos enviados.';
            setMessage(mensajeError);
        }
    };

    const handleConfirmConvert = async () => {
        setModalAbierto(false);

        const nuevosErrores = {};
        if (sueldosArchivo.length === 0) {
            setMessage("Debés subir al menos un archivo .dbf");
            return;
        }
        if (!campos.nroConvenio) nuevosErrores.nroConvenio = 'Este campo es obligatorio';
        if (!campos.fechaAcreditacion) nuevosErrores.fechaAcreditacion = 'Este campo es obligatorio';
        if (!campos.nroEnvio) nuevosErrores.nroEnvio = 'Este campo es obligatorio';
        if (!campos.tipoMov) nuevosErrores.tipoMov = 'Este campo es obligatorio';
        if (!campos.codConcepto) nuevosErrores.codConcepto = 'Este campo es obligatorio';

        setErrores(nuevosErrores);
        if (Object.keys(nuevosErrores).length > 0) return;

        setEstadoEnvio("cargando");

        const formData = new FormData();
        sueldosArchivo.forEach(file => formData.append('sueldosArchivo[]', file));
        if (adelantosArchivo) {
            formData.append('adelantosArchivo', adelantosArchivo, 'adelantos.xlsx');
        }

        formData.append('nroConvenio', campos.nroConvenio);
        formData.append('nroEnvio', campos.nroEnvio);
        formData.append('fechaAcreditacion', campos.fechaAcreditacion);
        formData.append('tipoMov', campos.tipoMov);
        formData.append('codConcepto', campos.codConcepto);

        try {
            const response = await axiosInstance.post(
                `${RUTA_API_SUELDOS}/procesar-sueldos`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    responseType: 'json',
                }
            );

            const { filename, fileContent } = response.data;

            const blob = new Blob([new TextEncoder().encode(fileContent)], { type: 'text/plain' });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = filename || 'sueldos_actualizados.txt';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);

            setEstadoEnvio("completado");
            setModificadoDesdeUltimaConversion(false);
        } catch (error) {
            let mensajeError = 'Ocurrió un error al procesar los archivos.';
            if (error.response?.status === 403) mensajeError = 'No tenés permiso para realizar esta acción.';
            if (error.response?.status === 401) mensajeError = 'No estás autorizado para realizar esta acción.';
            setMessage(mensajeError);
            setEstadoEnvio("idle");
        }
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', backgroundColor: '#fff', py: 4, px: 2 }}>
            <Paper elevation={3} sx={{ p: 5, borderRadius: 4, width: '100%', maxWidth: 900 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Typography fontWeight="bold" variant="subtitle1" sx={{ mb: 1 }}>
                            Archivo de sueldos
                        </Typography>

                        {sueldosArchivo.length < 6 && (
                            <DropZone
                                onClick={() => inputSueldosRef.current.click()}
                                onDragOver={(e) => {
                                    e.preventDefault();
                                    setDragOver('sueldos');
                                }}
                                onDragLeave={() => setDragOver(null)}
                                onDrop={(e) => handleMultiFileDrop(e, setSueldosArchivo)}
                                isDragging={dragOver === 'sueldos'}
                            >
                                <Typography variant="body1">
                                    Arrastrá aquí hasta 6 archivos .dbf o hacé click
                                </Typography>
                                <input
                                    type="file"
                                    hidden
                                    multiple
                                    accept=".dbf"
                                    ref={inputSueldosRef}
                                    onChange={(e) => handleMultiFileInput(e, setSueldosArchivo)}
                                />
                            </DropZone>
                        )}

                        <Box mt={2} display="flex" flexDirection="column" gap={1}>
                            {sueldosArchivo.map((file, index) => (
                                <FileDisplay key={index} file={file} onRemove={() => handleRemoveSueldoArchivo(index)} />
                            ))}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography fontWeight="bold" variant="subtitle1" sx={{ mb: 1 }}>
                            Archivo de adelantos
                        </Typography>
                        {!adelantosArchivo ? (
                            <DropZone
                                onClick={() => inputAdelantosRef.current.click()}
                                onDragOver={(e) => {
                                    e.preventDefault();
                                    setDragOver('adelantos');
                                }}
                                onDragLeave={() => setDragOver(null)}
                                onDrop={(e) => handleFileDrop(e, setAdelantosArchivo)}
                                isDragging={dragOver === 'adelantos'}
                            >
                                <Typography variant="body1">Arrastrá aquí el archivo o hacé click</Typography>
                                <input
                                    type="file"
                                    hidden
                                    ref={inputAdelantosRef}
                                    onChange={(e) => handleFileInput(e, setAdelantosArchivo)}
                                />
                            </DropZone>
                        ) : (
                            <FileDisplay
                                file={adelantosArchivo}
                                onRemove={() => {
                                    setAdelantosArchivo(null);
                                    setEstadoEnvio("idle");
                                    setModificadoDesdeUltimaConversion(true);
                                }}
                            />
                        )}
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            {[
                                { name: 'nroConvenio', label: 'Número de Convenio', type: 'text' },
                                { name: 'nroEnvio', label: 'Número de Envío', type: 'text' },
                                { name: 'tipoMov', label: 'Tipo de Movimiento', type: 'text' },
                                { name: 'codConcepto', label: 'Código de Concepto', type: 'text' },
                                { name: 'fechaAcreditacion', label: 'Fecha de Acreditación', type: 'date' },
                            ].map(({ name, label, type }, idx) => (
                                <Grid item xs={12} sm={3} key={idx}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                        {label}
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        type={type}
                                        name={name}
                                        value={campos[name]}
                                        onChange={handleChange}
                                        variant="outlined"
                                        error={!!errores[name]}
                                        helperText={errores[name]}
                                        InputLabelProps={type === 'date' ? { shrink: true } : {}}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Button
                            variant={estadoEnvio === "completado" ? "outlined" : "contained"}
                            color={estadoEnvio === "completado" ? "success" : "primary"}
                            size="large"
                            sx={{ mt: 2, px: 5, display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', gap: 1 }}
                            onClick={handleConvert}
                            disabled={estadoEnvio === "cargando" || !modificadoDesdeUltimaConversion}
                        >
                            {estadoEnvio === "cargando" ? (
                                <>
                                    <CircularProgress size={22} color="inherit" />
                                    Procesando...
                                </>
                            ) : estadoEnvio === "completado" ? (
                                <>
                                    <CheckCircleIcon />
                                    ¡Completado!
                                </>
                            ) : (
                                "Convertir"
                            )}
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
            <Dialog open={modalAbierto} onClose={() => setModalAbierto(false)}>
                <DialogTitle sx={{ fontWeight: 'bold' }}>¿Confirmar conversión?</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={2} mt={1}>
                        <DialogContentText>
                            Se encontraron los siguientes datos al procesar los archivos:
                        </DialogContentText>
                        <Box display="flex" alignItems="center" gap={1}>
                            <InsertDriveFileIcon color="primary" />
                            <Typography variant="body1">
                                Cantidad de registros: <strong>{cantRegistros}</strong>
                            </Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <CheckCircleIcon color="success" />
                            <Typography variant="body1">
                                Monto total: <strong>${montoTotal.toLocaleString()}</strong>
                            </Typography>
                        </Box>
                        <DialogContentText sx={{ mt: 2 }}>
                            ¿Deseás continuar con la conversión definitiva?
                        </DialogContentText>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button onClick={() => setModalAbierto(false)} color="secondary" variant="outlined">
                        Cancelar
                    </Button>
                    <Button onClick={handleConfirmConvert} color="primary" variant="contained" autoFocus>
                        Confirmar
                    </Button>
                </DialogActions>

            </Dialog>


        </Box>
    );
};

export default TabSueldos;
